import { Asset } from '../types/asset.interface';
import { AssetGroup } from '../types/asset-group.interface';

export interface AssetSelectItem {
  label: string;
  value: number;
}

export interface AssetGroupSelectItem {
  label: string;
  value: number;
  items: AssetSelectItem[];
}

const LOCALE_ALPHA: Intl.CollatorOptions = { sensitivity: 'base' };

const compareLabel = (a: { label: string }, b: { label: string }): number => a.label.localeCompare(b.label, undefined, LOCALE_ALPHA);

export function groupAssetsByAssetGroup(assets: readonly Asset[], groups: readonly AssetGroup[]): AssetGroupSelectItem[] {
  return groups
    .map(group => ({
      label: group.name,
      value: group.id,
      items: assets
        .filter(asset => asset.assetGroupId === group.id)
        .map(asset => ({ label: asset.name, value: asset.id }))
        .sort(compareLabel),
    }))
    .filter(group => group.items.length > 0)
    .sort(compareLabel);
}
